import React from "react";

const Footer = () => {
  return (
    <div>
      <p className="text-center">
        Crafted By <strong>Ahmed</strong> with ❤️
      </p>
    </div>
  );
};

export default Footer;
